import type { PassAction } from "../types/actions";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  moveCoin,
} from "../utils/zone-utils";

export function applyPass(
  state: WarchestState,
  action: PassAction,
): WarchestState {
  const zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceDown",
  );
  const newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  // PASS grants the initiative marker to the passing player if they don't already hold it
  const newInitiativeHolder =
    state.initiativeHolder === action.player
      ? state.initiativeHolder
      : action.player;
  return {
    ...state,
    playerZones: newPlayerZones,
    activePlayer: nextActive,
    initiativeHolder: newInitiativeHolder,
    phase: nextPhase,
    initiativeTransferredThisRound:
      nextPhase === "DRAW_COINS" ? false : state.initiativeTransferredThisRound,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}
